(function ($) {
    $(document).ready(function () {
        var slideSingle = $('body .portfolio-slider .wrapper .slider-wrap .slider .item').length;
        $('body .portfolio-slider .wrapper .slider-wrap .slider').slick({
            draggable: true,
            arrows: false,
            dots: true,
            fade: true,
            speed: 500,
            dotsClass: 'custom-dots',
            infinite: true,
            autoplay: true,
            pauseOnDotsHover: false,
            focusOnSelect: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            autoplaySpeed: 7000,
            cssEase: 'cubic-bezier(0.5, 0, 0.7, 1)',
        });
        if (slideSingle <= 1) {
            $('body .portfolio-slider .wrapper .slider-wrap .custom-dots li').hide();
        }
        else {
            $('body .portfolio-slider .wrapper .slider-wrap .custom-dots li').show();
        }
    });
    $(window).resize(function () {
        var slideSingle = $('body .portfolio-slider .wrapper .slider-wrap .slider .item').length;
        if (slideSingle <= 1) {
            $('body .portfolio-slider .wrapper .slider-wrap .custom-dots li').hide();
        }
        else {
            $('body .portfolio-slider .wrapper .slider-wrap .custom-dots li').show();
        }
    });
})(jQuery);